/* eslint-disable import/prefer-default-export */
import { includes } from 'ramda';

export const selector = ({ busy = '' }, { BUSY }) => includes(BUSY, busy);
